<template>
    <swiper class="swiper" ref="mySwiper" :options="swiperOption">
        <swiper-slide>
            <div class="swiper-card mx-4">
                <div class="d-flex justify-content-center mb-5">
                    <div class="circle user">
                        <img src="/images/autotrader-logo.png" class="img-fluid center">
                    </div>
                </div>
                <p class="mb-4"> {{$t('general.what_our_users_say_autotrader')}} </p>
                <h3> AutoTrader </h3>
            </div>
        </swiper-slide>
        <swiper-slide>
            <div class="swiper-card mx-4">
                <div class="d-flex justify-content-center mb-5">
                    <div class="circle user">
                        <img src="/images/car2go-logo.png" class="img-fluid center">
                    </div>
                </div>
                <p class="mb-4"> {{$t('general.what_our_users_say_car2go')}} </p>
                <h3> Car2Go </h3>
            </div>
        </swiper-slide>
        <swiper-slide>
            <div class="swiper-card mx-4">
                <div class="d-flex justify-content-center mb-5">
                    <div class="circle user">
                        <img src="/images/car2go-logo.png" class="img-fluid center">
                    </div>
                </div>
                <p class="mb-4"> {{$t('general.what_our_users_say_car2go')}} </p>
                <h3> Car2Go </h3>
            </div>
        </swiper-slide>
        <swiper-slide>
            <div class="swiper-card mx-4">
                <div class="d-flex justify-content-center mb-5">
                    <div class="circle user">
                        <img src="/images/autotrader-logo.png" class="img-fluid center">
                    </div>
                </div>
                <p class="mb-4"> {{$t('general.what_our_users_say_autotrader')}} </p>
                <h3> AutoTrader </h3>
            </div>
        </swiper-slide>
        <swiper-slide>
            <div class="swiper-card mx-4">
                <div class="d-flex justify-content-center mb-5">
                    <div class="circle user">
                        <img src="/images/autotrader-logo.png" class="img-fluid center">
                    </div>
                </div>
                <p class="mb-4"> {{$t('general.what_our_users_say_autotrader')}} </p>
                <h3> AutoTrader </h3>
            </div>
        </swiper-slide>
        <swiper-slide>
            <div class="swiper-card mx-4">
                <div class="d-flex justify-content-center mb-5">
                    <div class="circle user">
                        <img src="/images/car2go-logo.png" class="img-fluid center">
                    </div>
                </div>
                <p class="mb-4"> {{$t('general.what_our_users_say_car2go')}} </p>
                <h3> Car2Go </h3>
            </div>
        </swiper-slide>

        <div class="swiper-pagination" slot="pagination"></div>
    </swiper>
</template>

<script>
    import { Swiper, SwiperSlide } from 'vue-awesome-swiper'
    import 'swiper/css/swiper.css'

    export default {
        name: "FrontSwiper",
        title: '',
        components: {
            Swiper,
            SwiperSlide
        },
        data() {
            return {
                swiperOption: {
                    slidesPerView: 3,
                    spaceBetween: 0,
                    slidesPerGroup:3,
                    pagination: {
                        el: '.swiper-pagination',
                        type: "bullets",
                        clickable: true
                    },
                    breakpoints: {
                        0: {
                            slidesPerView: 1,
                            spaceBetween: 0
                        },
                        // when window width is >= 640px
                        768: {
                            slidesPerView: 3,
                            spaceBetween: 0
                        }
                    }
                },
            }
        }
    }
</script>

<style scoped>

</style>
